"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
function truncate(text, _a) {
    if (text === void 0) { text = ''; }
    var _b = _a === void 0 ? [6, 6] : _a, _c = __read(_b, 2), h = _c[0], t = _c[1];
    var head = text.slice(0, h);
    var tail = text.slice(-1 * t, text.length);
    return text.length > h + t ? [head, tail].join('...') : text;
}
exports.truncate = truncate;
//# sourceMappingURL=wallet-address.js.map